import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import 'reset-css/reset.css';
import '../color/color';
import '../color/color-hsl';
import '../grid/grid';
import '../typography/typography';
import FormHelperText from './form-helper-text';
import FormLabel from './form-label';
import FormInput from './form-input';
import FormNotice from './form-notice';
import cssLayout from './form-field-layout.css';

const FormFieldText = ({
  adjacent,
  disabled,
  error,
  helperText,
  id,
  labelTag,
  labelText,
  maxLength,
  name,
  onBlur,
  onChange,
  placeholder,
  slim,
  value,
  ...otherProps
}) => (
  <div
    className={classnames({
      [`${cssLayout['ds-form-field-layout']} ${
        cssLayout['ds-form-field-layout--adjacent']
      }`]: adjacent,
    })}
  >
    <FormLabel text={labelText} tag={labelTag} htmlFor={id} />
    {helperText && <FormHelperText text={helperText} />}
    <FormInput
      disabled={disabled}
      error={error}
      id={id}
      maxLength={maxLength}
      name={name}
      onBlur={onBlur}
      onChange={onChange}
      placeholder={placeholder}
      slim={slim}
      value={value}
      {...otherProps}
    />
    {error && <FormNotice text={error} />}
  </div>
);

FormFieldText.defaultProps = {
  adjacent: false,
  disabled: false,
  error: null,
  helperText: null,
  id: '',
  maxLength: null,
  name: '',
  onBlur: null,
  onChange: null,
  placeholder: null,
  labelTag: null,
  slim: null,
  value: '',
};

FormFieldText.propTypes = {
  adjacent: PropTypes.bool,
  disabled: PropTypes.bool,
  error: PropTypes.string,
  helperText: PropTypes.string,
  id: PropTypes.string,
  labelTag: PropTypes.string,
  labelText: PropTypes.string.isRequired,
  maxLength: PropTypes.number,
  name: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  slim: PropTypes.bool,
  value: PropTypes.string,
};

export default FormFieldText;
